import React from 'react';
import {connect} from "react-redux";
import {hashHistory} from "react-router";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import RecentlyViewedItems from "./recentlyViewedItems";

import {
  setCameFromPage,
  toggleSelectionWindow,
  toggleBathroomVisualizerOpen,
  changeMessageBoxState, toggleUserPopup, clearCart,
}
  from "../../actions/actionFunctions";
import {getCurrentLayout} from "../appLayout";

import ShoppingCart from "./shoppingCart";
import PriceWorksheetButton from "../ui/priceWorksheetButton";
import {changeQTRoutePath} from "../../misc/changeRoutePath";
import ShoppingCartTotalColumns from "./shoppingCartTotalColumns";
import VisualizerButton from "../ui/visualizerButton";
import ShoppingCartFooterSubParts from "./shoppingCartFooterSubParts";
import Analytics from "../../analytics";
import {toggleShowAssignQuotePopup} from "../../actions/assignPopupFunctions";
// import AgreeEmailCheckbox from "../common/agreeEmailCheckbox";
import ButtonGroup from "../ui/buttonGroup";
import {setCartFooterActiveButtonIndex} from "../../actions/shoppingCartFunctions";
import {handleSaveAndBackToDashboard} from "../common/dashboardButtons/backToDashboard";
import {showWizardInsteadOfQT} from "../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import ShoppingCartWizardFooterSteps from "../qkbPages/materialsWizard/shoppingCartWizardFooterSteps";
import {togglePriceWorksheetOpened} from "../../actions/priceWorksheetActions";
import {shouldDisplayPriceWorksheet} from "../priceWorksheet/discountFunctions";

class ShoppingCartFooter extends ShoppingCart {

  finalButton = null;
  saveButton = null;

  static propTypes = {
    showRecentlyViewedItems: PropTypes.bool.isRequired,
    recentlyItems: PropTypes.array.isRequired
  };

  handleSaveClick = () => {
    Analytics.sendClickEvent("shopping-cart-save");
    this.handleCheckOut();
  };

  goBack = () => {
    switch (this.props.cameFromPage) {
      case 'visualizer':
        this.props.toggleBathroomVisualizerOpen(true);
        hashHistory.push('visualizer');
        break;
      case 'quote-design':
        hashHistory.push('quote-design');
        break;
      case 'materials':
      default: {
        const layout = getCurrentLayout();
        layout.qtCategories ? changeQTRoutePath() : hashHistory.push('materials');
        this.props.toggleSelectionWindow(true, this.props.selectionGroup);
        break;
      }
    }
    this.props.setCameFromPage('');
  };

  renderFooterLeftSide = () => {
    const {showRecentlyViewedItems, recentlyItems, wizardIsActive, wizardList} = this.props;
    if (showRecentlyViewedItems) {
      return <RecentlyViewedItems recentlyItems={recentlyItems} isMobile={false}/>
    }
    const layout = getCurrentLayout();
    if (!layout.initialized) {
      return null
    }
    if (showWizardInsteadOfQT(wizardList, wizardIsActive)) {
     return <ShoppingCartWizardFooterSteps/>
    }
    const firstKey = Object.keys(layout.parts)[0];
    return <ShoppingCartFooterSubParts activePart={layout.parts[firstKey]}/>
  }

  render() {
    const {fabricatorData, networkConnection, showRecentlyViewedItems, editToken} = this.props;
    const fabricatorSettings = fabricatorData.settings;
    const showPriceWorksheet = shouldDisplayPriceWorksheet(this.props);

    const finalButton = this.getFinalButton();
    const finalButtonElement = finalButton ? (
      <button className="ui-button2 ui-button2--green pulsating--green"
              onClick={() => finalButton.onClick("all")}
              ref={(node) => this.finalButton = node}>
        <FormattedMessage id={finalButton.intlText}/>
      </button>
    ) : null;
    const saveButtonElement = (
      <button className="ui-button2 ui-button2--green pulsating--green"
              onClick={handleSaveAndBackToDashboard}>
        <FormattedMessage id={"dashboardButtons.save"}/>
      </button>
    );

    return (
      <div className={"dcart-footer" + (showRecentlyViewedItems ? " dcart-footer--with-recently" : "")}>
        {showRecentlyViewedItems
          ? <h5 className="dcart-footer__title"><FormattedMessage id="shoppingCart.recentlyViewedItemsTitle"/></h5>
          : null}
        <div className="dcart-footer__body">
          <div className="dcart-footer__body-left">{this.renderFooterLeftSide()}</div>
          <div className={"dcart-footer__body-right"
          + (showPriceWorksheet && (document.kvConfig.canSaveQuote !== false) ? " dcart-footer__body-right--with-price-worksheet" : "")
          + (!showRecentlyViewedItems && !showPriceWorksheet && (document.kvConfig.canSaveQuote !== false) ? " dcart-footer__body-right--with-visualizer-button" : "")}>
            {fabricatorSettings.showPricing && showRecentlyViewedItems && !fabricatorData.hidePricesFromUser ? (
              <div className="dcart-footer__body-right-total">
                <ShoppingCartTotalColumns/>
              </div>
            ) : null}
            <div className="dcart-footer__body-right-buttons">
              {!showRecentlyViewedItems && !showPriceWorksheet ? <VisualizerButton/> : null}
              {!networkConnection ? null : (
                <button className="selection-footer-buttons__button selection-footer-buttons__button--prev"
                        onClick={this.goBack}>
                  <FormattedMessage id="shoppingCart.footer.backButton"/>
                </button>
              )}
              {showPriceWorksheet ? <PriceWorksheetButton/> : null}
              {document.kvConfig.showBackToDashboard && fabricatorData.isCaesarStone ? saveButtonElement : null}
              {document.kvConfig.showBackToDashboard && !fabricatorData.isCaesarStone && !fabricatorData.isDalTile
                ? (
                  <ButtonGroup activeButtonIndex={this.props.cartFooterActiveButtonIndex}
                               dropDownHeight={126}
                               setActiveButtonIndex={this.props.setCartFooterActiveButtonIndex}
                               buttons={[{
                                 intlText: "dashboardButtons.save",
                                 // clickFunction: handleSaveAndBackToDashboard
                                 clickFunction: editToken ? handleSaveAndBackToDashboard : () => {
                                   this.props.toggleShowAssignQuotePopup(true, "save");
                                 }
                               }, {
                                 intlText: finalButton.intlText,
                                 clickFunction: finalButton.onClick.bind(this, "checkout")
                               }]}>
                    {/*<AgreeEmailCheckbox/>*/}
                  </ButtonGroup>
                ) : finalButtonElement}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {cartItems, cameFromPage, recentlyViewedItems, cartFooterActiveButtonIndex} = store.cartState;
  const {windowWidth, networkConnection} = store.serverState;
  const {wizardList, wizardIsActive} = store.wizardState;
  const {editToken} = store.userState;
  const {financePaymentType, discountSections, discountsReceived, financeActiveDiscount} = store.priceWorksheetState;

  return {
    windowWidth,
    cartItems,
    cameFromPage,
    selectionGroup: store.selectionState.selectionGroup,
    fabricatorData: store.fabricatorState,
    recentlyViewedItems,
    userIsLoggedIn: store.userState.userIsLoggedIn,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    discountSections,
    discountsReceived,
    cartFooterActiveButtonIndex,
    networkConnection,
    wizardList,
    wizardIsActive,
    editToken,
    financePaymentType,
    financeActiveDiscount,
  };
};

export default connect(mapStateToProps, {
  setCameFromPage,
  toggleSelectionWindow,
  toggleBathroomVisualizerOpen,
  changeMessageBoxState,
  toggleUserPopup,
  toggleShowAssignQuotePopup,
  setCartFooterActiveButtonIndex,
  clearCart,
  togglePriceWorksheetOpened,
})(ShoppingCartFooter);
